import { createContext, useState, useMemo } from "react";

const SubscriptionsContext = createContext({});

function SubscriptionsProvider({ children }) {
  const [selectedPub, setSelectedPub] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [selectedSubscriptionTags, setSelectedSubscriptionTags] = useState([]);
  const [subscriptionName, setSubscriptionName] = useState("");
  const [isSubscriptionFromPillsBar, setIsSubscriptionFromPillsBar] = useState(false);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [pendingSubscribePubId, setPendingSubscribePubId] = useState(null);

  const value = useMemo(
    () => ({
      selectedPub,
      setSelectedPub,
      modalShow,
      setModalShow,
      selectedSubscriptionTags,
      setSelectedSubscriptionTags,
      subscriptionName,
      setSubscriptionName,
      isSubscriptionFromPillsBar,
      setIsSubscriptionFromPillsBar,
      selectedLanguages,
      setSelectedLanguages,
      pendingSubscribePubId,
      setPendingSubscribePubId,
    }),
    [
      modalShow,
      selectedPub,
      selectedSubscriptionTags,
      subscriptionName,
      selectedLanguages,
      pendingSubscribePubId,
    ],
  );

  // noinspection JSXUnresolvedComponent
  return <SubscriptionsContext.Provider value={value}>{children}</SubscriptionsContext.Provider>;
}

export { SubscriptionsContext, SubscriptionsProvider };
